const MAX_INTEGER_DIGITS = 10;
const MAX_DECIMAL_DIGITS = 2;

export function appendDigit(current: string, digit: string): string {
  if (!/^\d$/.test(digit)) {
    throw new Error(`appendDigit: not a digit: ${digit}`);
  }
  const dot = current.indexOf('.');
  if (dot === -1) {
    // Integer portion: strip any run of leading zeros so '0' or '00…0' + 5 → '5'.
    if (/^0+$/.test(current)) return digit;
    if (current.length >= MAX_INTEGER_DIGITS) return current;
    return current + digit;
  }
  // Decimal portion.
  const decimalDigits = current.length - dot - 1;
  if (decimalDigits >= MAX_DECIMAL_DIGITS) return current;
  return current + digit;
}

export function appendDecimal(current: string): string {
  if (current.includes('.')) return current;
  if (current === '') return '0.';
  return current + '.';
}

export function backspace(current: string): string {
  return current.slice(0, -1);
}

export function clear(): string {
  return '';
}

export function parseToNumber(current: string): number {
  if (!current) return 0;
  const trimmed = current.endsWith('.') ? current.slice(0, -1) : current;
  const value = Number(trimmed);
  return Number.isFinite(value) ? value : 0;
}
